import { render, staticRenderFns } from "./MenuItemSecond.vue?vue&type=template&id=2a5a3bea"
import script from "./MenuItemSecond.vue?vue&type=script&lang=js"
export * from "./MenuItemSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports